import axios from 'axios';
import axiosInstance from '../../store/middleware/axiosInstance';

class People {
  // Login: the backend takes who this is from the Auth0 id token, not from the body
  getPerson = (data, idToken) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.REACT_APP_HAMMURABI_API}/people/sub`, data, {
          headers: {
            'X-Hammurabi-Key': `${process.env.REACT_APP_HAMMURABI_KEY}`,
            'X-Auth0-Token': idToken
          }
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };
  getPersonById = (id, allData = false) => {
    let url = `${process.env.REACT_APP_HAMMURABI_API}/people/${id}`;
    if (allData) url = `${process.env.REACT_APP_HAMMURABI_API}/people/${id}?allData=1`;
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(url, {
          headers: {
            'X-Hammurabi-Key': `${process.env.REACT_APP_HAMMURABI_KEY}`
          }
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  deleteInfo = (id) => {
    let url = `${process.env.REACT_APP_HAMMURABI_API}/people/${id}/deleteinfo`;
    return new Promise((resolve, reject) => {
      axiosInstance
        .delete(url, {
          headers: {
            'X-Hammurabi-Key': `${process.env.REACT_APP_HAMMURABI_KEY}`
          }
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  getSbId = () => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${process.env.REACT_APP_HAMMURABI_API}/sbid`, {
          headers: {
            'X-Hammurabi-Key': `${process.env.REACT_APP_HAMMURABI_KEY}`
          }
        })
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  // Before the email is verified there may be no SB session: the Auth0 id token says who asks
  resendEmail = (authId, idToken) => {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${process.env.REACT_APP_HAMMURABI_API}/people/resend-verification/${authId}`,
          {},
          {
            headers: {
              'X-Hammurabi-Key': `${process.env.REACT_APP_HAMMURABI_KEY}`,
              'X-Auth0-Token': idToken
            }
          }
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  getManagers = () => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${process.env.REACT_APP_HAMMURABI_API}/people/managers`, {
          headers: {
            'X-Hammurabi-Key': `${process.env.REACT_APP_HAMMURABI_KEY}`
          }
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  validateLegalStatus = (peopleId) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post(
          `${process.env.REACT_APP_HAMMURABI_API}/people/${peopleId}/validatelegal`,
          {},
          {
            headers: {
              'X-Hammurabi-Key': `${process.env.REACT_APP_HAMMURABI_KEY}`
            }
          }
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  rejectLegalStatus = (peopleId) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post(
          `${process.env.REACT_APP_HAMMURABI_API}/people/${peopleId}/rejectlegal`,
          {},
          {
            headers: {
              'X-Hammurabi-Key': `${process.env.REACT_APP_HAMMURABI_KEY}`
            }
          }
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  getPeople = () => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${process.env.REACT_APP_HAMMURABI_API}/people`, {
          headers: {
            'X-Hammurabi-Key': `${process.env.REACT_APP_HAMMURABI_KEY}`
          }
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  getPersonHistory = (id) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${process.env.REACT_APP_HAMMURABI_API}/people/${id}/loan-history`, {
          headers: {
            'X-Hammurabi-Key': `${process.env.REACT_APP_HAMMURABI_KEY}`
          }
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  getPersonClasification = (id) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${process.env.REACT_APP_HAMMURABI_API}/people/${id}/classification`, {
          headers: {
            'X-Hammurabi-Key': `${process.env.REACT_APP_HAMMURABI_KEY}`
          }
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  getPersonRefinanceStatus = (id) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${process.env.REACT_APP_HAMMURABI_API}/people/${id}/refinancestatus`, {
          headers: {
            'X-Hammurabi-Key': `${process.env.REACT_APP_HAMMURABI_KEY}`
          }
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  isActive = (id) => {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${process.env.REACT_APP_HAMMURABI_API}/people/${id}/isactive`, {})
        .then((response) => {
          resolve(response.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  // The Terms and Privacy Policy in force: { terms_version, terms_url, privacy_url }
  getCurrentTerms = () =>
    axios
      .get(`${process.env.REACT_APP_HAMMURABI_API}/legal/current`, {
        headers: { 'X-Hammurabi-Key': `${process.env.REACT_APP_HAMMURABI_KEY}` }
      })
      .then((response) => response.data.data);

  // The person accepts that version; the server records the date
  acceptTerms = (personId, termsVersion) =>
    axiosInstance
      .put(`${process.env.REACT_APP_HAMMURABI_API}/people/${personId}`, { terms_version: termsVersion })
      .then((response) => response.data);
}

const instance = new People();

export default instance;
